module.exports = __webpack_public_path__ + "static/media/tsunade.b230f383.webp";